module.exports = __webpack_public_path__ + "img/flow_customer-service.29c392b0.svg";